import axios from 'axios';
import api from '../api';

const url = 'https://status.tealcom.io/api/v2';

const getStatus = async () => {
  const { data } = await api.get(`api/portal/status`);
  return data;
};

const getScheduledMaintenance = async (params = {}) => {
  const { data } = await api.get(`api/portal/events/latest`, { params });
  return data;
};

const getActiveEvents = async (params = {}) => {
  const { data } = await api.get(`api/portal/events/active`, { params });
  return data;
};

const StatusPageService = {
  getStatus,
  getScheduledMaintenance,
  getActiveEvents,
};

export default StatusPageService;
